<script>
  import ReviewSettings from './ReviewSettings.svelte';
  import { onMount } from 'svelte';
  import { External, M } from '../../external';
  import Moderation from '../../CommentModeration/Moderation.svelte';
  import { makeWebsiteRequest } from '../../Common/tools';

  export let onComponentReady = () => {};

  let loading = true;

  let reviewSettings;

  const resourceDefinitions = [
    {
      id: 'product_review',
      title: M.PRODUCT_REVIEWS,
      hasDetails: true,
      getDetails: (resourceData, resourceId) => {
        const product = resourceData.find((product) => '' + product.id === resourceId);
        if (product) {
          return {
            title: product.title,
            imageData: product.images && product.images.length > 0 ? product.images[0].name : null,
            imageDatabase: product.images && product.images.length > 0 ? product.images[0].base : null
          };
        }
        return null;
      },
      fetchResourceData: async () => {
        let rawStoreProducts = [];

        const fetchPage = async (page) => {
          return await makeWebsiteRequest({
            action: 'getStoreProducts',
            data: {
              page: page,
              type: 0
            }
          });
        };

        const pagination = {
          page: 0,
          hasNextPage: true
        };

        while (pagination.hasNextPage && pagination.page < 100_000) {
          let response = await fetchPage(pagination.page);
          if (response.ok) {
            response = response.data;
          }

          pagination.page++;
          if (pagination.page >= response.pagesCount) {
            pagination.hasNextPage = false;
          }

          rawStoreProducts = [...rawStoreProducts, ...response.items];
        }

        return {
          options: rawStoreProducts.map((product) => {
            return { id: product.id, name: product.title };
          }),
          data: rawStoreProducts
        };
      }
    }
  ];

  onMount(() => {
    External.WebPlatform.getSessionDetails(() => {
      loading = false;
    });
  });

  const showReviewSettings = () => {
    External.Tools.showWindow({
      isModal: true,
      title: M.REVIEW_SETTINGS,
      width: 400,
      action: {
        onShow: (popup, ui) => {
          reviewSettings = new ReviewSettings({
            target: popup.getContentArea()
          });
          popup.bindComponent(reviewSettings);
        },
        onHide: function () {
          if (reviewSettings) {
            reviewSettings.$destroy();
            reviewSettings = null;
          }
        }
      },
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
          popup.component().saveChanges();
          popup.close();
        }),
        External.Button.MIDDLE_CANCEL
      ]
    });
  };
</script>

{#if !loading}
  <div class="account-settings store-settings">
    <div class="inner-wrapper members-table-wrapper">
      <div class="top-background-wrapper narrow-top-background">
        <div class="top-background">
          <h1 class="members-title f-left">{M.REVIEWS}</h1>
          <div class="f-right flex-centered">
            <a
              on:click={showReviewSettings}
              on:keypress={showReviewSettings}
              class="f-left middle-button color-default rounded-effect ml-5 blue"
              style="height: 39px; line-height: 39px;">
              {M.REVIEW_SETTINGS}
            </a>
          </div>
        </div>
      </div>
      <div class="content-wrapper members-content-wrapper">
        <div class="padded-crm-wrapper">
          <Moderation resourceType={'product_review'} {resourceDefinitions} {onComponentReady} />
        </div>
      </div>
    </div>
  </div>
{/if}
